import getConfig from 'next/config'

import { Util } from '@grandvisionhq/forms'
import type { AdyenContext } from '@grandvisionhq/payments'

import { isValidFullName, isValidStreetInfo, isValidStreetName } from '../util/form-validation'

const { publicRuntimeConfig } = getConfig()

const adyen = publicRuntimeConfig.adyen ?? {}

export const getAdyenConfig = (): AdyenContext => ({
  clientKey: adyen.clientKey,
  environment: adyen.environment,
  config: {
    creditcard: {
      hasHolderName: true,
      holderNameRequired: true,
      brands: ['mc', 'maestro', 'visa', 'amex'],
    },
    googlepay: {
      allowedAuthMethods: ['CRYPTOGRAM_3DS', 'PAN_ONLY'],
      allowedCardNetworks: ['MASTERCARD', 'VISA'],
      environment: adyen.gPayEnvironment,
      merchantName: 'Optica 2000',
      addressValidation: {
        streetName: (value: string) => isValidStreetName(value),
        fullName: (value: string) => isValidFullName(value),
        additionalStreetInfo: (value: string) => isValidStreetInfo(value),
      },
    },
    applepay: {
      addressValidation: {
        streetName: (value: string) => isValidStreetName(value),
        firstName: (value: string) => Util.validations.isText(value) && value.length <= 13,
        lastName: (value: string) => Util.validations.isText(value) && value.length <= 22,
        additionalStreetInfo: (value: string) => isValidStreetInfo(value),
      },
    },
  },
})
